import { useNitroStore } from "../../store/Store";

import NitroFilter from "../NitroFilter";
import { ProductIcon } from "../../icons/Product";

const ProductFilter = ({
  value,
  setValue,
  config,
  isMobile,
  disabled,
}: {
  value: string;
  setValue: (value: string) => void;
  config?: {
    customPaper?: boolean;
    shadow?: boolean;
    opaque?: boolean;
    autoFocus?: boolean;
    inputRef?: React.MutableRefObject<any> | null;
    valueRequired?: boolean;
    className?: string;
  };
  isMobile?: boolean;
  disabled?: boolean;
}) => {
  const [priorityProducts] = useNitroStore((state) => [state.priorityProducts]);

  return (
    <NitroFilter
      placeholder="Product"
      size="small"
      data={{
        options: priorityProducts.map((r) => {
          return { label: r, value: r };
        }),
      }}
      Icon={<ProductIcon color="#383838" />}
      value={value}
      setValue={setValue}
      config={config}
      isMobile={isMobile}
      disabled={disabled}
    />
  );
};

export default ProductFilter;
